export const MEDIA_QUERY_960 = 960
export const MEDIA_QUERY_1390 = 1390

export const isMediaQueryScreenMin = (width) => matchMedia(`screen and (min-width: ${width}px)`).matches

export const isMediaQueryScreenMax = (width) => matchMedia(`screen and (max-width: ${width}px)`).matches
